<template>
  <a-row type="flex" justify="start">
    <a-col style="width: 100%;">
      <a-card title="Announcements">
        <p v-for="announcement in dashboardData.announcements" v-html="announcement.text" :key="announcement.id"/>
      </a-card>
      <a-row type="flex"  justify="space-between" class="my-main-row">
        <a-card title="Members" style="flex:0.3">
          <p>{{dashboardData.membersWhoFollow.length}}</p>
        </a-card>
        <a-card title="Purchases Tracked" style="flex:0.3">
          <p>{{dashboardData.purchasesTracked.length}}</p>
        </a-card>
        <a-card title="Outstanding Rewards" style="flex:0.3">
          <p>{{dashboardData.outstandingRewards.length}}</p>
        </a-card>
      </a-row>
      <a-card title="Member Activity  Log">
        <div class="member-activity-container" v-for="item in dashboardData.pointHistory" :key="item.id">
          <div>
            <a-avatar :src="`${API_URL}/${item.user.logo}`" size="large" />
          </div>
          <div class="order-main">
            <span>
              {{getUserName(item.user)}} has just
              <span>{{getPointLabel(item)}}</span>
            </span>
            <p style="color: #8c8c8c;">
              {{moment(item.created_at).fromNow()}}
            </p>
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import {API_URL} from '../../constants'

export default {
  name: 'Dashboard',
  data () {
    return {
      message: '',
      moment,
      API_URL,
    }
  },
  mounted () {
    this.$store.dispatch('auth/getDashboardData')
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
    getUserName (user) {
      if (user.first_name || user.last_name) {
        return `${user.last_name} ${user.first_name}`
      } else {
        return user.email
      }
    },
    getPointLabel (item) {
      switch (item.type) {
        case 'follow':
          return 'become a member'
        case 'redeem':
          return 'redeem a gift'
        case 'manual':
          return `been added ${item.count}0 points manually`
        case 'qr_scan':
          return `got points by scanning a QR`
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      dashboardData: state => state.auth.dashboardData,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .title-on-dashboard{
    background: #FFF;
    margin-top: -10px;
    width: max-content;
    padding: 0 10px;
    margin-left: 10px;
  }
  .logout-btn {
    margin: 16px auto;
    display: flex;
  }
  .my-main-row {
    margin: 16px 0;
  }
  .activity-row{
    border: 1px solid black;
    width: 100%;
  }
  .member-activity-container {
    display: flex;
    height: 80px;
    align-items: center;
  }
  .grid-container {
    display: grid;
    height: 80px;
    grid-template-columns: 1fr 3fr;
    margin: 20px;
  }
  .client-logo{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .order-main {
    display: grid;
    align-items: center;
    grid-template-rows: 1fr 1fr;
    margin-left: 30px;
  }
  .order-main p{
    display: flex;
    align-items: center;
    margin: 0;
  }
  .counter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: baseline;
    height: 100%;
    font-size: 135px;
  }
  .centerTitle {
    width: 100%;
    justify-content: center;
    display: flex;
    margin-top: 20px;
    font-size:22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue